import { createSelector } from 'reselect'
import featureScopesSelector from './featureScopesSelector'

const isMiWiGrpTokenRefreshEnabledSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('enableMiWiGrpTokenRefresh'),
)

export default isMiWiGrpTokenRefreshEnabledSelector
